import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	question: {
		padding: '8px 0px',
	},
	nameContainer: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	actions: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	editName: {
		display: 'flex',
		flexDirection: 'row',
		'& .MuiFormControl-root': {
			marginLeft: 16,
		},
	},
	center: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	start: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	addArea: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 60,
		width: '100%',
		border: '2px dashed #ccc',
		borderRadius: 4,
		color: '#ccc',
		cursor: 'pointer',
		transition: '.2s',
		marginBottom: '1em',
		'& svg': {
			fill: '#ccc',
		},
		'&:hover': {
			color: '#000',
			border: '2px dashed #000',
			transition: '.2s',
			'& svg': {
				fill: '#000',
			},
		},
	},
	answers: {
		marginBottom: 16,
	},
}));

export default useStyles;
